var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4.53776 0 0 4.23982 0 9.94737L0.00522022 10.2773C0.0816865 12.6878 0.99608 14.9019 2.60753 16.5995L2.673 16.667L2.0123 20.8436L2.00069 20.953C1.95825 21.7441 2.83859 22.2847 3.53399 21.8455L7.382 19.415L7.77724 19.5192C8.791 19.7679 9.87002 19.8947 11 19.8947C17.4622 19.8947 22 15.6549 22 9.94737C22 4.23982 17.4622 0 11 0ZM11 2C16.3869 2 20 5.37589 20 9.94737C20 14.5189 16.3869 17.8947 11 17.8947C9.75406 17.8947 8.5945 17.717 7.54421 17.3748L7.42159 17.3433C7.1741 17.2961 6.91606 17.3439 6.70042 17.4801L4.332 18.975L4.72963 16.4705C4.78193 16.1401 4.66561 15.8055 4.41966 15.5788C2.85945 14.1408 2 12.1513 2 9.94737C2 5.37589 5.61312 2 11 2Z",
    fill: "#B489A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00439 9C7.55668 9 8.00439 9.44772 8.00439 10C8.00439 10.5128 7.61835 10.9355 7.12101 10.9933L7.00439 11C6.44772 11 6 10.5523 6 10C6 9.48716 6.38604 9.06449 6.88338 9.00673L7.00439 9Z",
    fill: "#B489A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0044 9C11.5567 9 12.0044 9.44772 12.0044 10C12.0044 10.5128 11.6184 10.9355 11.121 10.9933L11.0044 11C10.4477 11 10 10.5523 10 10C10 9.48716 10.386 9.06449 10.8834 9.00673L11.0044 9Z",
    fill: "#B489A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0044 9C15.5567 9 16.0044 9.44772 16.0044 10C16.0044 10.5128 15.6184 10.9355 15.121 10.9933L15.0044 11C14.4477 11 14 10.5523 14 10C14 9.48716 14.386 9.06449 14.8834 9.00673L15.0044 9Z",
    fill: "#B489A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.3b1f2586.svg";
export { ForwardRef as ReactComponent };